module.exports = __webpack_public_path__ + "static/classroom-setting-fb018e48733bf910b26acde41427c473.jpg";